/**
 * Strips HTML tags from a string.
 * Applies the tag-stripping regex in a loop until the string stabilises so
 * that nested / malformed constructs such as `<<img>img>` are fully removed
 * rather than leaving a stray `<img>` behind after the first pass.
 *
 * @param {string} html - Raw string that may contain HTML markup.
 * @returns {string} Plain text with all HTML tags removed.
 */
export const stripHtml = (html) => {
  if (!html) return '';
  let text = html;
  let prev;
  do {
    prev = text;
    text = text.replace(/<[^>]*>/g, '');
  } while (text !== prev);
  return text;
};
